import * as uuid from 'uuid';
import * as sessionStorage from 'shared/services/SessionStorage';
import { Observable } from 'rxjs/Observable';
import { paymentService } from './PaymentService';
import { cartService } from 'services/CartService';
import { langService } from './LangService';
import { enLang } from 'interfaces/IProductData';
import { enPaymentType } from 'enums/enPaymentType';
import { apiService } from 'shared/services';
import { parameterService } from 'services/ParameterService';
import { enParameters } from 'enums/enParameters';
import { showError } from 'shared/services/dialog';

interface IClientData {
  name: string;
  phone: string;
  email: string;
  personType: string;
  document?: string;
  address?: {
    postalCode: string;
    street: string;
    number: string;
    complement: string;
    district: string;
    cityId: string;
  };
}

export class UserService {
  private lastData = '';

  getSSID(): Observable<string> {
    return sessionStorage.getValue('ssid', () => uuid.v4().replace(/\d/gi, ''));
  }

  setBasicUser(): Observable<any> {
    return paymentService
      .getCart()
      .combineLatest(cartService.getCart(), langService.getLang(), parameterService.get(enParameters.sdoc).map(sdoc => !!sdoc))
      .filter(([data, cart]) => data.name && !!cart.transactionKey)
      .take(1)
      .switchMap(([data, cart, lang, sdoc]) => {
        const askDocument = cart.config.askDocument || sdoc;

        if (data.document && askDocument) {
          data.personType = data.document.length === 14 ? 'J' : 'F';
        }

        if (lang !== enLang.PT_BR) {
          data.personType = 'E';
        }

        const body: IClientData = {
          name: data.name,
          phone: data.phone,
          email: data.email,
          personType: data.personType || null
        };

        if (data.address && data.address.street) {
          body.address = {
            postalCode: `${data.address.postalCode}`,
            street: data.address.street,
            number: `${data.address.number}`,
            complement: data.address.complement || '',
            district: data.address.district,
            cityId: data.address.cityId
          };
        }

        if (!data.name || !data.phone || !data.email) {
          return Observable.empty();
        }

        // if (!this.validateClientData(body, askDocument)) {
        //   return Observable.throw(new CodeError('END_A'));
        // }

        if (cart.config.paymentType !== enPaymentType.FREE && lang !== enLang.EN_US) {
          body.document = data.document;
        }

        const tmpKey = JSON.stringify([data, cart.config.paymentType, lang]);

        if (tmpKey === this.lastData) {
          return Observable.empty();
          // return Observable.throw(new CodeError('END_A'));
        }

        this.lastData = tmpKey;

        return apiService.post(`/client/create/${cart.transactionKey}`, body);
      })
      .logError()
      .catch((err) => {
        showError(err).subscribe();
        return Observable.empty();
      });
  }

  // private validateClientData(data: IClientData, askDocument: boolean) {
  //   if (!data.name || !data.phone || !data.email) {
  //     return false;
  //   }

  //   if (askDocument && !data.personType) {
  //     return false;
  //   }

  //   if (!data.address) {
  //     return true;
  //   }

  //   const address = data.address;

  //   if (!address.street) {
  //     return false;
  //   }

  //   if (data.personType === 'E') {
  //     return true;
  //   }

  //   if (!address.postalCode.match(/^\d{5}-\d{3}$/) || !address.number || !address.district) {
  //     return false;
  //   }

  //   return true;
  // }
}

// tslint:disable-next-line:variable-name
export const UserServiceFactory = () => new UserService();

export const userService = UserServiceFactory();
